import { LocationType } from '@rematter/frontend-lib-api-client';

import { createMutationHook } from '~/shared/providers/api';

export const useCreateFreightLaneRouteMutation = createMutationHook(
  'transportation.freightLaneRouteCreate',
  (params: {
    locationAId: string;
    locationAType: LocationType;
    locationBId: string;
    locationBType: LocationType;
    distance?: string;
  }) => ({
    transportationFreightLaneRouteCreate: {
      __args: {
        input: {
          locationAId: params.locationAId,
          locationAType: params.locationAType,
          locationBId: params.locationBId,
          locationBType: params.locationBType,
          distance: params.distance ? Number(params.distance) : undefined,
        },
      },
      id: true,
      locationAId: true,
      locationAType: true,
      locationBId: true,
      locationBType: true,
    },
  }),
);
